import React, { Suspense, lazy } from "react";
import "./App.css";
import "./styles/landing.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import { CookieConsent } from "./components/CookieConsent";

// Lazy load pages
const Landing = lazy(() => import("./pages/Landing"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));
const UserManual = lazy(() => import("./pages/UserManual"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Loading fallback
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh',
    background: '#f8fafc'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '3px solid #e5e7eb',
      borderTopColor: '#1E8242',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite'
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <div className="App">
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              {/* Localized home pages */}
              <Route path="/ar" element={<Landing />} />
              <Route path="/ar/" element={<Landing />} />
              <Route path="/it" element={<Landing />} />
              <Route path="/it/" element={<Landing />} />
              <Route path="/es" element={<Landing />} />
              <Route path="/es/" element={<Landing />} />
              <Route path="/fr" element={<Landing />} />
              <Route path="/fr/" element={<Landing />} />
              <Route path="/de" element={<Landing />} />
              <Route path="/de/" element={<Landing />} />
              <Route path="/pt" element={<Landing />} />
              <Route path="/pt/" element={<Landing />} />
              <Route path="/ru" element={<Landing />} />
              <Route path="/ru/" element={<Landing />} />
              <Route path="/zh" element={<Landing />} />
              <Route path="/zh/" element={<Landing />} />
              <Route path="/cs" element={<Landing />} />
              <Route path="/cs/" element={<Landing />} />
              <Route path="/hr" element={<Landing />} />
              <Route path="/hr/" element={<Landing />} />
              <Route path="/da" element={<Landing />} />
              <Route path="/da/" element={<Landing />} />
              <Route path="/nl" element={<Landing />} />
              <Route path="/nl/" element={<Landing />} />
              <Route path="/fi" element={<Landing />} />
              <Route path="/fi/" element={<Landing />} />
              <Route path="/el" element={<Landing />} />
              <Route path="/el/" element={<Landing />} />
              <Route path="/he" element={<Landing />} />
              <Route path="/he/" element={<Landing />} />
              <Route path="/hi" element={<Landing />} />
              <Route path="/hi/" element={<Landing />} />
              <Route path="/hu" element={<Landing />} />
              <Route path="/hu/" element={<Landing />} />
              <Route path="/ko" element={<Landing />} />
              <Route path="/ko/" element={<Landing />} />
              <Route path="/ja" element={<Landing />} />
              <Route path="/ja/" element={<Landing />} />
              <Route path="/id" element={<Landing />} />
              <Route path="/id/" element={<Landing />} />
              <Route path="/no" element={<Landing />} />
              <Route path="/no/" element={<Landing />} />
              <Route path="/ms" element={<Landing />} />
              <Route path="/ms/" element={<Landing />} />
              <Route path="/pl" element={<Landing />} />
              <Route path="/pl/" element={<Landing />} />
              <Route path="/ro" element={<Landing />} />
              <Route path="/ro/" element={<Landing />} />
              <Route path="/sk" element={<Landing />} />
              <Route path="/sk/" element={<Landing />} />
              <Route path="/sv" element={<Landing />} />
              <Route path="/sv/" element={<Landing />} />
              <Route path="/th" element={<Landing />} />
              <Route path="/th/" element={<Landing />} />
              <Route path="/uk" element={<Landing />} />
              <Route path="/uk/" element={<Landing />} />
              <Route path="/tr" element={<Landing />} />
              <Route path="/tr/" element={<Landing />} />
              <Route path="/vi" element={<Landing />} />
              <Route path="/vi/" element={<Landing />} />

              {/* 404 for unknown subpaths under locale prefixes */}
              <Route path="/ar/*" element={<NotFound />} />
              <Route path="/it/*" element={<NotFound />} />
              <Route path="/es/*" element={<NotFound />} />
              <Route path="/fr/*" element={<NotFound />} />
              <Route path="/de/*" element={<NotFound />} />
              <Route path="/pt/*" element={<NotFound />} />
              <Route path="/ru/*" element={<NotFound />} />
              <Route path="/cs/*" element={<NotFound />} />
              <Route path="/hr/*" element={<NotFound />} />
              <Route path="/zh/*" element={<NotFound />} />
              <Route path="/da/*" element={<NotFound />} />
              <Route path="/nl/*" element={<NotFound />} />
              <Route path="/fi/*" element={<NotFound />} />
              <Route path="/el/*" element={<NotFound />} />
              <Route path="/he/*" element={<NotFound />} />
              <Route path="/hi/*" element={<NotFound />} />
              <Route path="/hu/*" element={<NotFound />} />
              <Route path="/ko/*" element={<NotFound />} />
              <Route path="/ja/*" element={<NotFound />} />
              <Route path="/id/*" element={<NotFound />} />
              <Route path="/no/*" element={<NotFound />} />
              <Route path="/ms/*" element={<NotFound />} />
              <Route path="/pl/*" element={<NotFound />} />
              <Route path="/ro/*" element={<NotFound />} />
              <Route path="/sk/*" element={<NotFound />} />
              <Route path="/sv/*" element={<NotFound />} />
              <Route path="/th/*" element={<NotFound />} />
              <Route path="/uk/*" element={<NotFound />} />
              <Route path="/tr/*" element={<NotFound />} />
              <Route path="/vi/*" element={<NotFound />} />
              <Route path="/privacy/" element={<PrivacyPolicy />} />
              <Route path="/terms/" element={<TermsOfUse />} />
              <Route path="/manual/" element={<UserManual />} />
              <Route path="/disclaimer/" element={<Disclaimer />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <CookieConsent />
        </div>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
